import { Drawer, type DrawerProps } from 'antd';

import './side-nav-drawer.less';

export const SideNavDrawer = (props: DrawerProps) => {
  return <Drawer className="side-nav-drawer" {...props} />;
};
